import React from 'react';
import { truncateFileName } from '@utils/fileUtils.ts';

interface AttachmentLinkProps {
  id: string;
  name: string;
  onActivate: (attachmentId: string, fileName: string) => void;
  maxLength?: number;
  className?: string;
  stopPropagation?: boolean;
}

const AttachmentLink: React.FC<AttachmentLinkProps> = ({
  id,
  name,
  onActivate,
  maxLength = 15,
  className = '',
  stopPropagation = true,
}) => {

  const handleActivate = (e?: React.SyntheticEvent) => {
    if (stopPropagation && e) {
      e.stopPropagation();
    }
    onActivate(id, name);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (stopPropagation) e.stopPropagation();
      onActivate(id, name);
    }
  };

  return (
    <span className={`attachment-item whitespace-normal ${className}`}>
      <span
        role="button"
        tabIndex={0}
        className="text-content-brand cursor-pointer"
        onClick={(e) => handleActivate(e)}
        onKeyDown={handleKeyDown}
      >
        {truncateFileName(name, maxLength)}
      </span>
    </span>
  );
};

export default AttachmentLink;